module.exports = __webpack_public_path__ + "img/happy_face_no_border.7c7981e9.svg";